<template>
  <Modal :title="translations.title" identifier="otherVendorsModal" size="750" is-full-mobile>
    <table class="table text-left mb-0">
      <thead>
        <tr>
          <th class="border-0 text-muted">{{ translations.vendor }}</th>
          <th class="border-0 text-muted">{{ translations.price }}</th>
          <th class="border-0 text-muted">{{ translations.shipping }}</th>
          <th class="border-0 text-muted"></th>
        </tr>
      </thead>
      <tbody>
        <OtherVendorsModalVendorRow
          :product="currentProduct"
          :current="true"
          :translations="translations"
        />
        <OtherVendorsModalVendorRow
          v-for="product in products"
          :key="`vendor_${product.vendor_name}`"
          :product="product"
          :translations="translations"
        />
      </tbody>
    </table>
  </Modal>
</template>

<script>
import Modal from "./Modal";
import OtherVendorsModalVendorRow from "./OtherVendorsModalVendorRow";

export default {
  name: "OtherVendorsModal",
  components: { Modal, OtherVendorsModalVendorRow },
  props: {
    currentProduct: {
      required: true,
      type: Object,
    },
    products: {
      required: true,
      type: Array,
    },
    translations: {
      required: true,
      type: Object,
    },
  },
};
</script>
